<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-3">
                                        <b-form-input
                                            v-model="filter"
                                            class="form-control"
                                            type="search"
                                            :placeholder="$t('label.search')"
                                            v-on:change="searchListing"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <div class="col-md-8"></div>
                                    <div class="col-md-1 d-flex justify-content-end align-items-center">
                                        <b-button
                                            variant="secondary"
                                            class="mr-1"
                                            @click="searchListing"
                                            :disabled="!status.list && loading"
                                            :title="$t('label.refresh')"
                                            v-b-tooltip:hover
                                        >
                                            <i class="mdi mdi-refresh"></i>
                                        </b-button>
                                        <b-dropdown
                                            variant="warning"
                                            no-caret
                                            right
                                            menu-class="dropdown-menu-250"
                                        >
                                            <template #button-content>
                                                <i class="mdi mdi-filter"></i>
                                            </template>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    Level
                                                </label>
                                                <multiselect
                                                    v-model="levelFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="levelDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    Context
                                                </label>
                                                <multiselect
                                                    v-model="contextFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="contextDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    User
                                                </label>
                                                <multiselect
                                                    v-model="userFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="userDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                        </b-dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                v-if="status.list && !loading"
                                :items="tableRows"
                                :fields="fields"
                                :per-page="perPage"
                                responsive="sm"
                            >
                                <template #cell(message)="data">
                                    <span>
                                        {{ data.item.message ? data.item.message.length > 40 ? data.item.message.substring(0, 40) + '...' : data.item.message : '--' }}
                                    </span>
                                </template>
                                <template #cell(exceptionCode)="data">
                                    <span>{{ data.item.exceptionCode ? data.item.exceptionCode : '--' }}</span>
                                </template>
                                <template #cell(user)="data">
                                    <span>{{ data.item.user ? data.item.user.firstName + ' ' + data.item.user.lastName : '--' }}</span>
                                </template>
                                <template #cell(hostname)="data">
                                    <span>{{ data.item.hostname ? data.item.hostname : '--' }}</span>
                                </template>
                                <template #cell(level)="data">
                                    <b-badge :variant="data.item.level === 'critical' ? 'danger' : data.item.level === 'warning' ? 'warning' : data.item.level === 'error' ? 'dark' : 'secondary'">
                                        {{ data.item.level }}
                                    </b-badge>
                                </template>
                                <template #cell(context)="data">
                                    <b-badge
                                        :variant="data.item.context == 'http' ? 'success' : 'primary'"
                                    >
                                        {{ data.item.context }}
                                    </b-badge>
                                </template>
                                <template #cell(actions)="data">
                                    <a
                                        href="javascript:void(0);"
                                        :class="[data.item.requestLog ? 'text-warning' : 'text-secondary']"
                                        v-b-tooltip.hover
                                        :title="$t('module.requestLog')"
                                        v-on:click="data.item.requestLog ? openRequestLog(data.item) : ''"
                                    >
                                        <i class="mdi mdi-web font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info ml-1"
                                        v-b-tooltip.hover
                                        :title="$t('label.detail')"
                                        v-on:click="openForm(data.item)"
                                    >
                                        <i class="mdi mdi-eye font-size-18"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list && !loading"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                        </div>
                        <div v-if="totalPage" class="d-flex flex-column flex-md-row justify-content-md-between align-items-center">
                            <small class="text-muted">{{ $t('label.total') }}: {{ totalPage }}</small>
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalPage"
                                :per-page="perPage"
                                v-on:change="pageNavigation"
                                variant="info"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="error-log-form"
            :title="$t('label.viewX', [$t('module.errorLog')])"
            @hidden="closeForm"
            hide-footer
            hide-header-close
            size="xl"
            centered
        >
            <b-container fluid>
                <ErrorLogForm
                    :errorLog="errorLog"
                    @done="closeForm"
                    ref="errorLogForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="error-request-log-form"
            :title="$t('label.viewX', [$t('module.requestLog')])"
            @hidden="closeRequestLog"
            hide-footer
            hide-header-close
            size="xl"
            centered
        >
            <b-container fluid>
                <RequestLogForm
                    :requestLog="requestLog"
                    @done="closeRequestLog"
                    ref="requestLogForm"
                />
            </b-container>
        </b-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import i18n from "@/i18n";
import { SESSION, SHARED } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { mapState } from "vuex";
import { errorLogMethods, lookupMethods } from "@/state/api";
import { ERROR_LOG_MODULE } from "@/state/api/errorLog.state";
import ErrorLogForm from "@/views/pages/admin/diagnostic/errorLog/errorLogForm";
import RequestLogForm from "@/views/pages/admin/diagnostic/requestLog/requestLogForm";

export default {
    components: { Multiselect, ErrorLogForm, RequestLogForm },
    async created() {
        await this.lookupUser({});

        sessionHelper.clearSearch(SESSION.ERROR_LOG_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();

        this.loading = false;
    },
    data() {
        return {
            filter: "",
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            levelDdl: [
                ddlHelper.getOptionAll(),
                { value: 'warning', text: 'warning' },
                { value: 'critical', text: 'critical' },
                { value: 'error', text: 'error' },
            ],
            contextDdl: [
                ddlHelper.getOptionAll(),
                { value: 'http', text: 'http' },
                { value: 'console', text: 'console' },
            ],
            levelFilter: ddlHelper.getOptionAll(),
            contextFilter: ddlHelper.getOptionAll(),
            userFilter: null,
            fields: [
                { key: 'createdAt', label: i18n.t("label.createdAt"), sortable: true, class: 'text-nowrap' },
                { key: 'user', label: 'User', sortable: true, class: 'text-nowrap' },
                { key: 'context', label: 'Context', sortable: false, class: 'text-nowrap' },
                { key: 'level', label: 'Level', sortable: false, class: 'text-nowrap' },
                { key: 'message', label: 'Message', sortable: true, class: '' },
                { key: 'exceptionCode', label: 'Exception Code', sortable: true, class: 'text-nowrap' },
                { key: 'hostname', label: 'Hostname', sortable: true, class: 'text-nowrap' },
                { key: 'actions', label: i18n.t("label.action"), sortable: false, class: 'text-nowrap' },
            ],
            searchCriteria: {},
            errorLog: this.defaultErrorLog(),
            requestLog: this.defaultRequestLog(),
            loading: true,
        };
    },
    methods: {
        ...errorLogMethods,
        ...lookupMethods,
        defaultRequestLog() {
            return {
                uuid: "",
                method: "",
                path: "",
                files: null,
                requestPayload: null,
                responsePayload: null,
                ip: "",
                url: "",
                scheme: "",
                host: "",
                port: "",
                cookies: null,
                userAgent: "",
                statusCode: "",
                success: false,
                performance: null,
                createdAt: "",
                updatedAt: "",
                user: null,
                errorLog: null,
            };
        },
        defaultErrorLog() {
            return {
                uuid: "",
                level: "",
                exceptionClass: "",
                message: "",
                exceptionCode: "",
                sourceFile: "",
                sourceLine: "",
                stackTrace: "",
                previous_exception: "",
                performance: null,
                hostname: "",
                context: "",
                createdAt: "",
                updatedAt: "",
                user: null,
            };
        },
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.ERROR_LOG_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.ERROR_LOG_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }
            if(isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    searchValue: "",
                    searchArray: [],
                };
            }
            this.getErrorLogList(this.searchCriteria);
        },
        getErrorLogList(filter) {
            this.getAllErrorLog({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.ERROR_LOG_SEARCH, filter);
        },
        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.ERROR_LOG_SEARCH);
            filter.pageNumber = pageNumber;
            this.getErrorLogList(filter);
        },
        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            if (this.levelFilter?.value == SHARED.DEFAULT_ALL_VALUE)
                delete this.searchCriteria.level;
            else if (this.levelFilter?.value)
                this.searchCriteria.level = this.levelFilter.value;

            if (this.contextFilter?.value == SHARED.DEFAULT_ALL_VALUE)
                delete this.searchCriteria.context;
            else if (this.contextFilter?.value)
                this.searchCriteria.context = this.contextFilter.value;

            if (this.userFilter?.value == SHARED.DEFAULT_ALL_VALUE)
                delete this.searchCriteria.user;
            else if (this.userFilter?.value)
                this.searchCriteria.user = this.userFilter.value;

            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getErrorLogList(this.searchCriteria);
        },
        openForm(data) {
            if (data?.uuid) {
                this.errorLog = {
                    ...this.defaultErrorLog(),
                    ...data,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('error-log-form');
            });
        },
        closeForm() {
            this.errorLog = this.defaultErrorLog();
            this.$bvModal.hide('error-log-form');
        },
        openRequestLog(data) {
            if (data?.requestLog) {
                this.requestLog = {
                    ...this.defaultRequestLog(),
                    ...data.requestLog,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('error-request-log-form');
            });
        },
        closeRequestLog() {
            this.requestLog = this.defaultRequestLog();
            this.$bvModal.hide('error-request-log-form');
        },
    },
    computed: {
        ...mapState(ERROR_LOG_MODULE, ['status']),
        userDdl() {
            return [
                ddlHelper.getOptionAll(),
                ...this.$store.state.api.lookup.userDdl,
            ];
        },
        tableRows() {
            return this.$store.state.api.errorLog.list.data || [];
        },
        totalPage() {
            return this.$store.state.api.errorLog.list.pagination.total || 0;
        },
    },
}
</script>
<style>
.context-popover {
    max-width: 600px;
}

</style>
